import React, { ReactNode, useEffect } from "react";
import { useAuthStore } from "./authStore";

interface AuthBootstrapProps {
    children: ReactNode;
}

const AuthBootstrap = ({ children }: AuthBootstrapProps) => {
    const isPreparingApp = useAuthStore((s) => s.isPreparingApp);

    useEffect(() => {
        useAuthStore.getState().loadResourcesAndDataAsync();
    }, []);

    if (isPreparingApp) return null;
    return <>{children}</>;
};

export default AuthBootstrap;
